// const apiUrl = process.env.REACT_APP_SERVER_BASE_URL;
import api, { api2 } from "../controllers/api";
import Papa from "papaparse";
import Cookies from "js-cookie";
import { getAssignVehicleAPI, vehicleAssign } from "./carAllocation";

const transformKeys = (obj) => {
  const newObj = { ...obj }; // create a shallow copy of the original object
  delete newObj["Driver.Account.id"];
  delete newObj["Driver.DriverVerification.driver_id"];
  return Object.keys(newObj).reduce((acc, key) => {
    const newKey = key
      .replace(/^Driver\./, "")
      .replace(/^Account\./, "")
      .replace(/^DriverVerification\./, "")
      .replace(/^DriverOnboardingDetail\./, "");
    acc[newKey] = newObj[key];
    return acc;
  }, {});
};

const extractStatusFields = (driver) => {};
const transformDrivers = (drivers) => {
  return drivers.map((driver) => {
    const statusFields = extractStatusFields(driver);
    return {
      ...driver,
      stage: driver.status,
      // status: statusFields
    };
  });
};
export const getAllDriversDetailsApi = async (limit, page) => {
  try {
    const url = `/driver/status${limit ? "?limit=" + limit + "&" : ""}${page ? "page=" + page + "&" : ""}`;
    const data = await api.get(url);
    const filteredData = data.results.drivers.map(transformKeys);
    return transformDrivers(filteredData);
  } catch (error) {
    throw error;
  }
};
// getDriverDetailsWithIdApi
export const getDriverDetailsWithIdApi = async (driverId) => {
  try {
    const url = `/driver/single/${driverId}`;
    const data = await api.get(url);
    let getVehicleData = {};

    const onboarding = {
      ...data.results.driverDetails,
      ...data.results.driverOnboardingDetails,
      ...data.results.accountDetails,
      requested_cars: data?.results?.requested_cars,
    };
    const chequeData = data.results.chequeData;
    if (onboarding?.inactive_at === null) {
      getVehicleData = await getAssignVehicleAPI(driverId);
    }
    const newdata = {
      canDMReactivate: data.results?.canDMReactivate,
      canOAEditAfterDR: data.results?.canOAEditAfterDR,
      onboarding: onboarding,
      verification: data.results.verificationDetails,
      paymentHistory: data.results.paymentHistory,
      allocationData: data.results?.additionalDetails,
      schemeDetails: data.results?.schemeDetails,
      vehicleAssignData: getVehicleData?.results,
      walletDetails: data.results?.walletDetails,
      assigned_emi_detail: data.results?.assigned_emi_detail,
      settlementDetails: data.results?.settlementDetails,
      isWaiverButtonActive: data.results?.isWaiverButtonActive ?? false,
      canCarBeAutoAssigned: data.results?.canCarBeAutoAssigned,
      canCarBeAutoAssignedReason: data.results?.canCarBeAutoAssignedReason,
      schemeDeleted: data.results?.schemeDeleted,
      isSDMDriverRelated: data.results?.isSDMDriverRelated ?? false,
      canSecondaryBecomePrimary: data.results?.canSecondaryBecomePrimary ?? false,
      checks: data.results?.checks ?? {},
      isPrimaryDriver: data.results?.isPrimaryDriver,
      chequeData: chequeData,
      leadData: data.results?.leadData,
    };
    return newdata;
  } catch (error) {
    throw error;
  }
};

// api to get driver document image url to open it
export const getDriverDocumentImageApi = async (accountId, fileName) => {
  // request
  // accountId , docType

  // response
  // {
  //   "status": "success",
  //   "message": "Download your doc from here",
  //   "errors": "",
  //   "results": {
  //     "url": "https://yourbucket.s3.amazonaws.com/account_id/docType"
  //   }
  // }
  try {
    const url = `/driver/downloadDocs/${accountId}?docType=${fileName}`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const addSingleLead = async (data) => {
  try {
    const url = `/driver/onboard`;
    const result = await api.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

//CSV uplaod url - "http://qa-api.carrum.co.in/api/v1/driver/onboardUsingCSV"

// export const csvUploadAPI = `${BASE_URL}/driver/onboardUsingCSV`
export const csvUploadAPI = `${process.env.REACT_APP_SERVER_URL}/driver/onboardUsingCSV`;

export const uploadCSVAPI = async (formData) => {
  const csvUploadAPI = `${process.env.REACT_APP_SERVER_URL}/driver/onboardUsingCSV`;
  const authToken = Cookies.get("authToken");

  try {
    const res = await fetch(
      csvUploadAPI,

      {
        method: "POST",
        headers: {
          Authorization: `carrum ${authToken}`,
        },
        body: formData,
      }
    );

    if (!res.ok) {
      throw new Error(`Error uploading file: ${res.statusText}`);
    }
    const data = await res.json();
    if (data.results?.data?.notIncludedDrivers) {
      downloadCsv(data.results.data.notIncludedDrivers);
    }
    // if(res.)
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};
const downloadCsv = (data) => {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "not_onboarded_drivers.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const requestCountAPI = async () => {
  try {
    const url = `/dashboard/apisStats`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
